import { getTheme } from "../core/theme";
import { importMediaPaths } from "../core/useMedia";
import _config from "./config.js";
// types
import type { Config } from "../../scripts/types/config";

export { default as icons } from "../core/icons";
export { useMedia } from "../core/useMedia";

export const config = _config as Config;

importMediaPaths(
	require.context("./media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/), // filter not possible to extract into a constant
	require.context("../core/media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/) // filter not possible to extract into a constant
);

export const muiTheme = getTheme("#008fff");
